export default __webpack_public_path__ + "static/media/01_photo.3909b6af.jpg";